<template>
  <u>
    <button v-if="isDisabled" type="button" class="btn btn-link font-poppins font-weight-light font-size-16" disabled>
      <u>{{ labelName }}</u>
    </button>

    <a v-else
      :data-target="'#' + dataTargetId"
      data-toggle="modal"
      href="#"
       v-on:click="clearErrors"
      class="font-poppins font-weight-light font-size-16 color-blue"
    >{{ labelName }}</a>
  </u>
</template>

<script>

export default {
  name: "ModalTriggerLink",
  props: {
    dataTargetId: {
      type: String,
      required: true
    },
    labelName: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
      resetErrors: {
        type: Boolean,
          default: false,
      }
  },

    methods: {
        clearErrors() {
            this.$page.props.errors.reason = null;
      }
    }
}
</script>
